import React from 'react';


export default ({color}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
      <path fill={color || '#0092e5'} d="M266.127,140a6.127,6.127,0,1,0,6.127,6.127A6.127,6.127,0,0,0,266.127,140Zm0,10.722a4.6,4.6,0,1,1,4.6-4.6A4.6,4.6,0,0,1,266.127,150.722Zm8.649,4.054h0a.766.766,0,0,1-1.083,0l-2.708-2.708,1.083-1.083,2.708,2.708A.766.766,0,0,1,274.776,154.776Z" transform="translate(-260 -140)"/>
    </svg>
  )
}